var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarBookmarkInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 37,
    viewBox: "0 0 40 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 960285",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 21",
    opacity: 0.6,
    d: "M0.0234375 0H39.0234V37L0.0234375 0Z",
    fill: "#63666A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Primary",
    d: "M26.3328 3L28.3602 6.84375L32.6422 7.58438L29.6117 10.6992L30.2305 15L26.3328 13.0828L22.4328 15L23.0516 10.6992L20.0234 7.58438L24.3031 6.84375L26.3328 3Z",
    fill: "#63666A",
    fillOpacity: 0.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarBookmarkInactive);
export default __webpack_public_path__ + "static/media/star-bookmark-inactive.96f836f679ef2f1edfd97d4d1ca0992b.svg";
export { ForwardRef as ReactComponent };